import { useState } from "react";
import { VisualBuilderViewports } from "@intelligems/ig-types/schemas/visual-builder/viewports";
import { Stack, useTheme } from "@mui/material";
import { ReverseProxy } from "@src/components/ReverseProxy/ReverseProxy";
import { PREVIEW_IFRAME_ID } from "@src/features/experienceBuilder/constants";
import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";
import { PageState } from "@src/features/experienceBuilder/pageState/PageState";
import { ExperienceBuilderController } from "@src/features/experienceBuilder/ExperienceBuilderController";
import { getOrganization } from "@src/store/slices/organization";
import { getIgBundleUrl } from "@src/utils/intelligemsThemeSnippets";

const { getEmbeddedPreviewSrc, getCacheKey, getDevice, getDemoUrl } =
  ExperienceBuilderSelector;

const { setLoadState, setLocation, setPluginVersion } = ExperienceBuilderAction;

export const ExperienceBuilderPreview = () => {
  const dispatch = useDispatch();
  const url = useSelector(getEmbeddedPreviewSrc);
  const cacheKey = useSelector(getCacheKey);
  const device = useSelector(getDevice);
  const demoUrl = useSelector(getDemoUrl);
  const org = useSelector(getOrganization);

  // In demo mode, tell the proxy to inject this org's bundle into the previewed
  // store; otherwise send an empty value so the proxy clears the bundle cookie.
  const bundleUrl = demoUrl && org?.id ? getIgBundleUrl(org.id) : "";
  const theme = useTheme();

  const [controller] = useState(() => new ExperienceBuilderController());
  controller.on("loadState", (state) => dispatch(setLoadState(state)));
  controller.on("location", (location) => dispatch(setLocation(location)));
  controller.on("version", (version) => dispatch(setPluginVersion(version)));

  return (
    <Stack
      sx={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
      }}
    >
      <Stack
        sx={{
          flex: 1,
          position: "relative",
          height: "100%",
          width: "100%",
          maxWidth:
            device === "mobile"
              ? `${VisualBuilderViewports.mobile.width}px`
              : undefined,
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: theme.igShadows.low,
        }}
      >
        <ReverseProxy
          controller={controller}
          id={PREVIEW_IFRAME_ID}
          src={controller.getSrc({ url, cacheKey, bundleUrl })}
          sx={{ width: "100%", height: "100%" }}
        />
        <PageState />
      </Stack>
    </Stack>
  );
};
